import { Component, OnInit, Input } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store';

@Component({
  selector: 'app-past-due-report',
  templateUrl: './past-due-report.component.html',
  styleUrls: ['./past-due-report.component.css']
})
export class PastDueReportComponent extends ReportBase implements OnInit {

  report;
  controls = [
    { name: 'name', type: 'text', title: 'Name' },
    { name: 'dueDate', type: 'date', title: 'Due Date' },
    { name: 'teamGroup', type: 'text', title: 'Team' },
    { name: 'gender', type: 'select', title: 'Gender', options: [ { text: 'Male', value: 'm' }, { text: 'Female', value: 'f' } ] },
    { name: 'reason', type: 'text', title: 'Reason' },
    { name: 'amount', type: 'number', title: 'AMOUNT' }
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getPastDueReportData');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/past-due-report/past-due-report.component.ts